import script from "./ViewOneProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewOneProduct.vue?vue&type=script&setup=true&lang=js"

import "./ViewOneProduct.vue?vue&type=style&index=0&id=24cb2627&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24cb2627"]])

export default __exports__